module.exports = __webpack_public_path__ + "static/media/master_im_3.9a24886d.jpg";